import {
  orderDrawerPrimaryButtonClass,
} from "src/constants/orderDrawerButtons";
import { PortaledModalFrame } from "src/components/common/PortaledModalFrame";

export interface BatchOperationLineResult {
  correlationId: string;
  success: boolean;
  errorMessage?: string;
}

export interface BatchOperationSummaryModalProps {
  open: boolean;
  operationName: string;
  results: BatchOperationLineResult[];
  onClose: () => void;
}

function shortOrderId(correlationId: string): string {
  return correlationId.length > 5 ? `#${correlationId.slice(-5)}` : correlationId;
}

export function BatchOperationSummaryModal({
  open,
  operationName,
  results,
  onClose,
}: BatchOperationSummaryModalProps) {
  if (!open) return null;

  const successCount = results.filter((r) => r.success).length;
  const failureCount = results.length - successCount;
  const title =
    failureCount === 0 ? "Batch operation successful" : "Batch operation completed with errors";

  const bodyLines: string[] = [
    `Operation: ${operationName}`,
    "",
    `Total: ${results.length} order(s)`,
    `Successful: ${successCount}`,
    `Failed: ${failureCount}`,
  ];

  const failures = results.filter((r) => !r.success);
  if (failures.length > 0) {
    bodyLines.push("", "Failed orders:");
    failures.forEach((r) => {
      const suffix = r.errorMessage ? `: ${r.errorMessage}` : "";
      bodyLines.push(`- Order ${shortOrderId(r.correlationId)}${suffix}`);
    });
  }

  return (
    <PortaledModalFrame onClose={onClose} panelClassName="max-w-lg" panelStyle={{ maxWidth: 480 }}>
      <div className="px-6 py-5 flex flex-col max-h-[min(85dvh,560px)] min-h-0">
        <h2
          id="modal-title"
          className={`text-lg font-semibold shrink-0 ${failureCount === 0 ? "text-[#166534]" : "text-[#B42318]"}`}
        >
          {title}
        </h2>
        <pre className="mt-4 text-sm text-[#374151] whitespace-pre-wrap font-sans leading-relaxed flex-1 min-h-0 overflow-y-auto border border-[#f3f4f6] rounded-lg bg-[#fafafa] p-3">
          {bodyLines.join("\n")}
        </pre>
        <div className="mt-5 flex justify-end shrink-0">
          <button type="button" onClick={onClose} className={orderDrawerPrimaryButtonClass}>
            OK
          </button>
        </div>
      </div>
    </PortaledModalFrame>
  );
}
